import { observer } from "mobx-react";
import { WalletStore } from "../../stores/wallet/wallet-store";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import "./confirm-delete-payment-method-modal.scss";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
interface IProps {
    store: WalletStore;
    onCloseClick: () => void;
}

const ConfirmDeletePaymentMethodModal: React.FC<IProps> = observer(({ store, onCloseClick }) => {
    return (
        <ConfirmModal
            title={<FontBody1 variant={FONT_VARIANT.BOLD}>{"Are you sure you want to remove your payment method?"}</FontBody1>}
            text={
                <div className="confirm-delete-payment-method-in-wallet-modal">
                    {"Removing your payment method will prevent you from adding credits to your wallet. Any remaining balance will still be used to generate labels."}
                </div>
            }
            isCloseDisabled={store.isDeleting}
            cancelButton={{
                title: "Cancel",
                onClick: onCloseClick,
                disabled: store.isDeleting,
            }} okButton={{
                title: "Remove payment method",
                onClick: store.deletePaymentMethodHandler,
                hasLoader: true,
                isLoading: store.isDeleting,
            }}
        />
    );
});

export default ConfirmDeletePaymentMethodModal;